import * as cookies from 'tiny-cookie'
import axios from 'axios'
import store from '@/store'

export var apiAxios

export function auth (to, from, next, goNext) {
  apiAxios = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    timeout: 10000,
    headers: {
      'Accept': 'application/json'
    }
  })
  if (process.env.NODE_ENV !== 'production') {
    store.dispatch('setUser',
      {
        'id': 'adria',
        'sesmanCookie': 'bcb148cb-d053-4dc4-8361-5326ec39c8d5',
        'userRole': 'Manager',
        'grups': [
          { 'chat_id': null, 'descripcio': 'Ordinador', 'id': 4, 'id_categoria': 2 },
          { 'chat_id': null, 'descripcio': 'Projector', 'id': 5, 'id_categoria': 2 },
          { 'chat_id': -468255626, 'descripcio': 'Control de faltes', 'id': 8, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Fitxes dels alumnes', 'id': 10, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Gestió de treballadors', 'id': 11, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Gestio de matricula', 'id': 12, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Matrícula', 'id': 13, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Butlletins acadèmics', 'id': 14, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Inventari', 'id': 15, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Seguiment fpct', 'id': 16, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Configuració de grups', 'id': 17, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Gestió de les sol·licitud de convenis', 'id': 18, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Correspondència de grups', 'id': 20, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Comptabilitat', 'id': 22, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': "Promoció d'alumnes", 'id': 23, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Orles', 'id': 24, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Tiquets', 'id': 25, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Altres', 'id': 26, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Canvi de contrasenya', 'id': 43, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': 'Horaris', 'id': 54, 'id_categoria': 4 },
          { 'chat_id': -468255626, 'descripcio': "Menú d'aplicatius", 'id': 56, 'id_categoria': 4 }
        ]
      })
    goNext()
  } else {
    // Cogemos la cookie de sesman
    const sesmanCookie = cookies.getCookie('sesman')
    // Si no la tiene que vaya a login
    if (isNullOrUndefined(sesmanCookie)) {
      // Y eliminamos el usuario guardado localmente
      store.dispatch('setUser', {})
      window.location = `${process.env.VUE_APP_SESMAN_LOGIN}?next=${window.location.href}`
    }
    // Si la tiene la usamos para conseguir el nombre de usuario
    axios.get(`${process.env.VUE_APP_SESMAN_CHECK}/${sesmanCookie}?app_name=${process.env.VUE_APP_NAME}`).then(response => {
      const username = response.data
      // Si no tiene nombre de usuario lo mandamos a login
      if (isNullOrUndefined(username)) {
        window.location = `${process.env.VUE_APP_SESMAN_LOGIN}?next=${window.location}`
      }
      // Si ya está guardado pasa
      if (store.getters.getUser.id === username) {
        apiAxios.defaults.headers.common['Authorization'] = `Bearer ${store.getters.getUser.sesmanCookie}`
        goNext()
      } else {
        // Cogemos información de la sesión mediante el nombre de usuario
        axios.get(`${process.env.VUE_APP_SESMAN_SESSION}/${sesmanCookie}?app_name=${process.env.VUE_APP_NAME}`).then(response => {
          var sessionData = response.data
          // Si hay información de la sesión y tiene definido un nombre de usuario
          if (!isNullOrUndefined(sessionData) && 'username' in sessionData) {
            // Lo guardamos
            addUser(sessionData['username'], sesmanCookie, goNext)
          } else {
            window.location = `${process.env.VUE_APP_SESMAN_LOGIN}?next=${window.location.href}`
          }
        }).catch(e => {
          window.location = `${process.env.VUE_APP_SESMAN_LOGIN}?next=${window.location.href}`
          throw e
        })
      }
    }).catch(e => {
      window.location = `${process.env.VUE_APP_SESMAN_LOGIN}?next=${window.location.href}`
      throw e
    })
  }
}

export function authManager (to, from, next) {
  // Primero que pase por sesman
  auth(to, from, next, function () {
  // Comprobamos que sea admin
    if (store.getters.getUser.userRole === 'Manager') {
      next()
    } else {
      next({ path: '/forbidden' })
    }
  })
}

function addUser (username, sesmanCookie, goNext) {
  axios.get(`${process.env.VUE_APP_ROOT_API}/users/${username}`, {
    headers: { 'Authorization': `Bearer ${sesmanCookie}` }
  }).then(response => {
    store.dispatch('setUser', createUser(username, sesmanCookie, response.data))
    apiAxios.defaults.headers.common['Authorization'] = `Bearer ${store.getters.getUser.sesmanCookie}`
    goNext()
  })
}

function isNullOrUndefined (arg) {
  return arg === null || arg === undefined || arg === 'undefined'
}

function createUser (username, sesmanCookie, user) {
  return {
    'id': username,
    'sesmanCookie': sesmanCookie,
    'userRole': user.type,
    'grups': user.grups ? user.grups : null
  }
}
